import React from 'react';
import { Box, Paper, Typography, Link } from '@mui/material';
import { TicketSummary } from '../types';
import { Launch as LaunchIcon } from '@mui/icons-material';

interface ConfirmationStepProps {
  ticketSummary: TicketSummary;
}

export const ConfirmationStep: React.FC<ConfirmationStepProps> = ({ ticketSummary }) => {
  return (
    <Box sx={{ my: 3, textAlign: 'center' }}>
      <Typography variant="h6" color="primary" gutterBottom>
        Ticket Created Successfully
      </Typography>
      <Typography variant="body1" paragraph>
        Your ticket has been created and all attachments have been uploaded.
      </Typography>
      <Paper elevation={1} sx={{ p: 3, maxWidth: 400, mx: 'auto', bgcolor: '#f8f9fa' }}>
        <Typography variant="subtitle1" gutterBottom>
          {ticketSummary.title}
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>Status:</strong> {ticketSummary.status}
        </Typography>
        {ticketSummary.id && (
          <Link 
            href={`/ticketEasy/messages?highlight=${ticketSummary.id}`} 
            color="primary" 
            sx={{ 
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mt: 2
            }}
          >
            View Ticket <LaunchIcon sx={{ ml: 0.5, fontSize: '1rem' }} />
          </Link>
        )}
      </Paper>
    </Box>
  );
};